<template>
  <div class="tit-box">
    <ul style="display: flex; flex-direction: column;">
      <li style="display: inline-flex;" v-if="cardBlngDls.length > 0">
        <span class="info1">결제수단을 선택해주세요.</span>
      </li>
      <li style="display: inline-flex;" v-else>
        <span class="info1">등록된 결제수단이 없습니다. 결제수단관리에서 카드를 등록해 주세요.</span>
      </li>
    </ul>
  </div>
  <div class="layer-cho-card" style="width:50%;"
       v-for="{bcrtnoMngSn, issuCdcoNm, mskngCrdNo} in cardBlngDls"
       :key="'tab_' + bcrtnoMngSn"
  >
    <div class="card-con">
      <div :class="selBcrtnoMngSn === bcrtnoMngSn ? 'current' : ''"
           @click="stlmMnSel_click(bcrtnoMngSn)"
      >
        <div class="entry-tit">
          <i class="far fa-credit-card-front"></i> 카드빌링
        </div>
        <div class="entry-con">
          <dl>
            <dt>{{ issuCdcoNm }}</dt>
            <dd>{{ mskngCrdNo }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'취소'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'결제수단 등록'"
         :color="'purple'"
         @click="btnRgst_click"/>
  </div>
</template>

<script setup>
import {onBeforeMount, ref, defineEmits, defineProps} from "vue";
import {getUtils, getStore} from "@/utils/import";

const { $cmmn, $axios, $alert} = getUtils();
const { $loading} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  },
  gdsCntrctSn: {
    type: Number,
    required: true
  },
});

const emits = defineEmits(['choc', 'close']);

const selBcrtnoMngSn = ref(null);
const getGdsCntrctDlByGdsCntrctSn = async () => {
  const {data} = await $axios.get(
      '/api/svc/gds-cntrct-dl/by-gds-cntrct-sn',
      {params: {gdsCntrctSn: props.gdsCntrctSn}}
  );
  return data;
};


const cardBlngDls = ref([]);
const getBcrtnoMngDls = async (params) => {
  const { data } = await $axios.get(
      '/api/stlm/bcrtno-mng-dls',
      {params}
  );
  return data;
};

const init = async () => {
  const [bcrtnoMngDls, gdsCntrctDl] = await Promise.all(
      [
        getBcrtnoMngDls({
          fcltySn: props.fcltySn
        }),
        getGdsCntrctDlByGdsCntrctSn()
      ]
  );

  cardBlngDls.value = bcrtnoMngDls;
  if (gdsCntrctDl.bcrtnoMngSn != null) {
    selBcrtnoMngSn.value = gdsCntrctDl.bcrtnoMngSn;
  }
};

const stlmMnSel_click = (bcrtnoMngSn) => {
  if (selBcrtnoMngSn.value === bcrtnoMngSn) {
    selBcrtnoMngSn.value = null;
  } else {
    selBcrtnoMngSn.value = bcrtnoMngSn;
  }
};

const btnCancl_click = () => {
  emits('close');
}

const btnRgst_click = async () => {
  try {
    $loading.on();

    if (selBcrtnoMngSn.value == null) {
      await $alert('선택된 결제수단이 없습니다. 결제수단을 선택해주세요.');
      return false;
    }

    emits('rgst', {bcrtnoMngSn: selBcrtnoMngSn.value});
    emits('close');
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }

}

onBeforeMount(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
